import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./saily.png"
								alt="saily"
								className="work-image"
							/>
							<div className="work-title">Saily</div>
							<div className="work-subtitle">
								Senior Software Engineer
							</div>
							<div className="work-duration">2025 Apr - Present</div>
						</div>

						<div className="work">
							<img
								src="./nfq.jpeg"
								alt="nfq"
								className="work-image"
							/>
							<div className="work-title">NFQ Technologies</div>
							<div className="work-subtitle">
								Senior Software Engineer & TL
							</div>
							<div className="work-duration">2018 Sep - 2025 Apr</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
